import _extends from "@babel/runtime/helpers/extends";
import { CancerqldNav as Base } from "@cancer-council-queensland/react";
import { useEffect, useState } from "react";
import { cleanHref } from "../lib";
import { jsx as _jsx } from "react/jsx-runtime";
export var CancerqldNav = props => {
  var [mainItems, setMainItems] = useState([]);
  useEffect(() => {
    setMainItems(props.mainItems.map(mainItem => {
      return _extends({}, mainItem, {
        href: cleanHref(mainItem.href),
        sections: mainItem.sections.map(section => {
          return _extends({}, section, {
            href: cleanHref(section.href),
            items: section.items.map(item => {
              return _extends({}, item, {
                href: cleanHref(item.href)
              });
            })
          });
        })
      });
    }));
  }, [props.mainItems]);
  return /*#__PURE__*/_jsx(Base, _extends({}, props, {
    mainItems: mainItems
  }));
};
//# sourceMappingURL=cancerqld_nav.js.map